import React from 'react';
import styled from '@2pulse/responsive';
import { ITimesheet, IUser } from '@app/common';
import { DateTime } from 'luxon';

interface TimesheetCardProps {
  timesheet: ITimesheet;
}

export const TimesheetCard: React.FC<TimesheetCardProps> = ({ timesheet }) => {
  const user = timesheet.userId as unknown as IUser;
  const userName = user && typeof user === 'object' 
    ? `${user.firstname} ${user.lastname}` 
    : 'N/A';

  const clockingIn = DateTime.fromISO(timesheet.clockingIn as any);
  const clockingOut = DateTime.fromISO(timesheet.clockingOut as any);
  const duration = clockingOut.diff(clockingIn, ['hours', 'minutes']);
  const hours = Math.floor(duration.hours);
  const minutes = Math.floor(duration.minutes);

  return (
    <Container>
      <Title>Détails du pointage</Title>
      
      <Section>
        <Label>Utilisateur</Label>
        <Value>{userName}</Value>
      </Section>

      <Section>
        <Label>Heure d'arrivée</Label>
        <Value>{clockingIn.toFormat('dd/MM/yyyy à HH:mm')}</Value>
      </Section>

      <Section>
        <Label>Heure de départ</Label>
        <Value>{clockingOut.toFormat('dd/MM/yyyy à HH:mm')}</Value>
      </Section>

      <Section>
        <Label>Durée</Label>
        <Value>{`${hours}h ${minutes}min`}</Value>
      </Section>
    </Container>
  );
};

const Container = styled.View(({ theme }) => ({
  padding: 20,
  backgroundColor: theme.colors.white,
  borderRadius: 8,
}));

const Title = styled.Text(({ theme }) => ({
  fontSize: 18,
  fontWeight: 'bold',
  color: theme.colors.oxfordblue,
  marginBottom: 20,
}));

const Section = styled.View({
  marginBottom: 15,
});

const Label = styled.Text(({ theme }) => ({
  fontSize: 12,
  color: theme.colors.gray,
  marginBottom: 5,
}));

const Value = styled.Text(({ theme }) => ({
  fontSize: 14,
  color: theme.colors.oxfordblue,
  fontWeight: '500',
}));

